import { Component } from '@angular/core';
import { ArticleService } from 'src/app/services/article.service';
import { EXTERNAL_POPUP_TEXT_EN } from 'shared/constants';
import { Article } from 'shared/types';
import { Page, Section } from 'shared/location-enums';

@Component({
    selector: 'contact-us-en',
    templateUrl: './contact-us.component.html',
})
export class ContactUsComponent {
    headerArticle: Article;

    constructor(articleService: ArticleService) {
        this.headerArticle = articleService.getOne(Page.contactUs, Section.header);
    }

    ngAfterViewInit() {
        const links = Object.values(document.getElementsByTagName('a')).filter(link => !link.href.includes('.gov') && !link.baseURI.includes(link.hostname));

        links.forEach(linkEl => {
            const href = linkEl.href;
            linkEl.addEventListener('click', (ev: MouseEvent) => {
                ev.preventDefault();
                ev.stopPropagation();
                if (window.confirm(EXTERNAL_POPUP_TEXT_EN)) {
                    const tab = window.open(href, '_blank', 'noopener');
                    if (tab) {
                        tab.opener = null;
                    }
                }
            });
        });
    }
}
